<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold pt-2" v-html="title"></div>
    <div class="col-12 col-md-8 col-xl-9">
    <button type="button"
        v-for="(item, index) in items"
        :key="index"
        :class="['btn btn-sm btn-outline-filter', filterUiState('fireResistanceInner', item.value)]"
        v-on:click="selectValue(item.value)">{{ item.title }}</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionfireResistanceInner',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Feuer&shy;wider&shy;stand (innen)',
      items: [
        { title: 'F 30-B', value: 'F-30-B' },
        { title: 'F 60-B', value: 'F-60-B' },
        { title: 'F 90-B', value: 'F-90-B' },
        // { title: 'KH\u208260', value: 'K260' },
        { title: 'F 60-B / K\u208260', value: 'F-60-B-K260' },
        { title: 'F 90-B / K\u208260', value: 'F-90-B-K260' },
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('fireResistanceInner', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title.split('&shy;').join(''),
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: null
      })

      this.$store.dispatch('filter/setValue', {
        name: 'fireResistanceInner',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
